import { render, staticRenderFns } from "./BrandCollectionLink.vue?vue&type=template&id=76c665a8&scoped=true&"
import script from "./BrandCollectionLink.vue?vue&type=script&lang=js&"
export * from "./BrandCollectionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c665a8",
  null
  
)

export default component.exports